import { render, staticRenderFns } from "./ConfirmDzd.vue?vue&type=template&id=ba1fc84e&scoped=true&"
import script from "./ConfirmDzd.vue?vue&type=script&lang=js&"
export * from "./ConfirmDzd.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDzd.vue?vue&type=style&index=0&id=ba1fc84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1fc84e",
  null
  
)

export default component.exports